import { createSlice } from "@reduxjs/toolkit";


export const billsSlice = createSlice({
  name: "bills",
  initialState : {
    data: {}
  },


  reducers: {
    setBills: (state, { payload }) => {
      state.data = {...state.data, bills: payload }
    },
  },
});

export const { setBills } = billsSlice.actions;

export default billsSlice.reducer;
